export default __webpack_public_path__ + "static/media/backBody.14f5b9f3.png";